<script setup lang="ts">
defineProps<{
  name: 'arrow-right' | 'chevron-left' | 'x' | 'qr' | 'plus' | 'minus';
}>();

const PATHS = {
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  'chevron-left': 'M15 5 8 12l7 7',
  x: 'm6 6 12 12M18 6 6 18',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
};
</script>

<template>
  <svg
    v-if="name === 'qr'"
    class="qr-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
  >
    <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" />
    <path d="M14 14h2v2h-2zM18 14h2v6h-6v-2h4zM14 20h2" />
  </svg>
  <svg v-else viewBox="0 0 24 24" aria-hidden="true" fill="none">
    <path :d="PATHS[name]" />
  </svg>
</template>

<style scoped>
svg {
  width: 32px;
  height: 32px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.qr-icon {
  stroke-width: 1.5;
}
</style>
